import type { IntegrationsStatus } from '@jt/shared';
import { useQuery } from '@tanstack/react-query';
import { get } from '../api/client';

export const integrationsKey = ['integrations'] as const;

export const useIntegrations = () =>
  useQuery({
    queryKey: integrationsKey,
    queryFn: () => get<IntegrationsStatus>('/integrations/status'),
    staleTime: 30_000,
  });
